module.exports={render:function (){var _vm=this;
  return _vm._h('div', [_vm._h('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        _vm.reverseValue()
      }
    }
  }, [_vm._s(_vm.value)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2fd340c4!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Reverse.vue
// module id = 127
// module chunks = 2